import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import realUserService from "../../helpers/real_user_helper";

interface UserData {
  id?: number;
  username: string;
  email: string;
  role: string;
  status: string;
  avatar?: string;
}

export const getUserList = createAsyncThunk("users/getUserList", async () => {
  try {
    const response = await realUserService.getUserList();
    return response;
  } catch (error) {
    return error;
  }
});

export const addUserList = createAsyncThunk(
  "users/addUserList",
  async (userData: Omit<UserData, "id">) => {
    try {
      const response = await realUserService.addUserList(userData);
      toast.success("Usuário adicionado com sucesso", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.error("Falha ao adicionar usuário", { autoClose: 2000 });
      return error;
    }
  }
);

export const updateUserList = createAsyncThunk(
  "users/updateUserList",
  async (userData: UserData) => {
    try {
      const response = await realUserService.updateUserList(userData);
      toast.success("Usuário atualizado com sucesso", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.error("Falha ao atualizar usuário", { autoClose: 2000 });
      return error;
    }
  }
);

export const deleteUserList = createAsyncThunk("users/deleteUserList", async (userId: number) => {
  try {
    const response = await realUserService.deleteUserList(userId);
    toast.success("Usuário deletado com sucesso", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error("Falha ao deletar usuário", { autoClose: 2000 });
    return error;
  }
});

export const getUserGrid = createAsyncThunk("users/getUserGrid", async () => {
  try {
    const response = await realUserService.getUserGrid();
    return response;
  } catch (error) {
    return error;
  }
});

export const addUserGrid = createAsyncThunk(
  "users/addUserGrid",
  async (userData: Omit<UserData, "id">) => {
    try {
      const response = await realUserService.addUserGrid(userData);
      toast.success("Usuário adicionado com sucesso", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.error("Falha ao adicionar usuário", { autoClose: 2000 });
      return error;
    }
  }
);

export const updateUserGrid = createAsyncThunk(
  "users/updateUserGrid",
  async (userData: UserData) => {
    try {
      const response = await realUserService.updateUserGrid(userData);
      toast.success("Usuário atualizado com sucesso", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.error("Falha ao atualizar usuário", { autoClose: 2000 });
      return error;
    }
  }
);

export const deleteUserGrid = createAsyncThunk("users/deleteUserGrid", async (userId: number) => {
  try {
    const response = await realUserService.deleteUserGrid(userId);
    toast.success("Usuário deletado com sucesso", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error("Falha ao deletar usuário", { autoClose: 2000 });
    return error;
  }
});
